'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { ChevDownIcon } from './Icons';

const links = [
  { href: '/', label: 'Home' },
  { href: '/chi-siamo', label: 'Chi siamo' },
  { href: '/contatti', label: 'Contatti' },
];

const products = [
  { href: '/clinic', label: 'SOIIA Clinic', desc: 'Gestionale per studi medici', dot: 'clinic' },
  { href: '/safe', label: 'SOIIA Safe', desc: 'Emergenze e accessi aziendali', dot: 'safe' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  const isProductActive = pathname.startsWith('/clinic') || pathname.startsWith('/safe');

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link href="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>
          <Image
            src="/images/logo-v2.png"
            alt="SOIIA — Organizza, prenota, gestisci"
            width={1000}
            height={600}
            style={{ display: 'block', height: 46, width: 'auto' }}
            priority
          />
        </Link>

        <nav>
          <ul className="nav-links">
            {links.map((l) => (
              <li key={l.href}>
                <Link href={l.href} className={pathname === l.href ? 'active' : ''}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li className="nav-dropdown-wrapper">
              <button className={`nav-dropdown-trigger ${isProductActive ? 'active' : ''}`} aria-label="Prodotti">
                Prodotti <ChevDownIcon size={10} color="currentColor"/>
              </button>
              <div className="nav-dropdown">
                {products.map((p) => (
                  <Link key={p.href} href={p.href} className="nav-dropdown-item">
                    <span className={`product-dot ${p.dot}`}/>
                    <span className="product-info">
                      <span className="product-name">{p.label}</span>
                      <span className="product-desc">{p.desc}</span>
                    </span>
                  </Link>
                ))}
              </div>
            </li>
          </ul>
        </nav>

        <div className="header-cta">
          <Link href="/" className="btn btn-primary btn-sm">
            Inizia gratis
          </Link>
        </div>

        <button
          className="hamburger"
          aria-label="Menu"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span /><span /><span />
        </button>
      </div>

      {mobileOpen && (
        <div className="mobile-menu">
          <ul>
            {links.map((l) => (
              <li key={l.href}>
                <Link href={l.href} onClick={() => setMobileOpen(false)}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mobile-products">
            {products.map((p) => (
              <Link key={p.href} href={p.href} onClick={() => setMobileOpen(false)}>
                <span className="product-dot" style={{ background: p.dot === 'clinic' ? '#16A34A' : '#F97316' }}/>
                {p.label}
              </Link>
            ))}
          </div>
          <Link href="/" className="btn btn-primary btn-block" onClick={() => setMobileOpen(false)}>
            Inizia gratis
          </Link>
        </div>
      )}
    </header>
  );
}
